import { Link } from "react-router-dom";
import { Reveal, SectionHeading } from "@/components/motion";
import { ArrowUpRight } from "lucide-react";

const ENDPOINTS = [
  { method: "POST", path: "/event/ingest", desc: "Send raw delivery events — coordinates, timestamps, route IDs, and driver claims." },
  { method: "POST", path: "/event/verify", desc: "Get truth, compliance, and anomaly results for a single event or batch of events." },
  { method: "GET", path: "/event/truth", desc: "Retrieve truth engine evaluations — distance, integrity, and scenario tags." },
  { method: "GET", path: "/event/audit", desc: "Pull immutable audit trails and signatures for liability, claims, and regulatory review." },
  { method: "GET", path: "/event/compliance", desc: "Check geofence, proximity, and arrival window compliance across your network." },
];

const ApiOverview = () => (
  <section id="api" data-testid="api-overview" className="border-b border-border">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-24 lg:py-32">
      <div className="flex flex-wrap items-end justify-between gap-8">
        <SectionHeading index="06" eyebrow="API Overview" title="Routing-agnostic by design." />
        <Reveal delay={0.15}>
          <Link
            data-testid="api-overview-docs-link"
            to="/docs"
            className="font-mono text-[11px] tracking-[0.2em] uppercase border border-foreground px-6 py-3 hover:bg-foreground hover:text-background transition-colors duration-200 flex items-center gap-2"
          >
            Full Reference <ArrowUpRight className="w-4 h-4" />
          </Link>
        </Reveal>
      </div>
      <p className="mt-6 text-base md:text-lg text-muted-foreground max-w-2xl">
        A clean API surface for delivery platforms, TMS vendors, fleet systems, and fraud/insurance
        stacks.
      </p>
      <div className="mt-16 border-t border-l border-border">
        {ENDPOINTS.map((e, i) => (
          <Reveal key={e.path} delay={i * 0.05}>
            <Link
              to="/docs"
              data-testid={`endpoint-${e.method}-${e.path.replace(/\//g, "-")}`}
              className="group grid sm:grid-cols-12 gap-4 items-center border-b border-r border-border px-6 lg:px-10 py-7 hover:bg-muted/50 transition-colors duration-200"
            >
              <div className="sm:col-span-2">
                <span
                  className={`font-mono text-[11px] tracking-widest px-3 py-1.5 ${
                    e.method === "POST" ? "bg-foreground text-background" : "border border-foreground"
                  }`}
                >
                  {e.method}
                </span>
              </div>
              <div className="sm:col-span-4">
                <code className="font-mono text-base sm:text-lg font-semibold text-telemetry">{e.path}</code>
              </div>
              <div className="sm:col-span-6 flex items-center justify-between gap-4">
                <p className="text-sm text-muted-foreground">{e.desc}</p>
                <ArrowUpRight className="w-4 h-4 shrink-0 opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default ApiOverview;
